import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, type RouterConfigOptions, withRouterConfig } from '@angular/router';

import { provideNgxMask } from 'ngx-mask';

import { logHttpInterceptor, provideAppI18n, provideFinUi, provideMockableApi } from '@drf/core';
import { PORTFOLIO_API, PortfolioMockService, PortfolioService } from '@drf/entities/portfolio';
import { provideWalletConnection } from '@drf/entities/wallet';

import { routes } from './app.routes';

export const APP_ROUTER_CONFIG: RouterConfigOptions = {
  canceledNavigationResolution: 'computed',
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withRouterConfig(APP_ROUTER_CONFIG)),
    provideHttpClient(withInterceptors([logHttpInterceptor])),
    provideFinUi(),
    provideAppI18n(),
    provideWalletConnection(),
    provideMockableApi(PORTFOLIO_API, PortfolioService, PortfolioMockService),
    provideNgxMask(),
  ],
};
